import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  CreateDictionariesLocationModel,
  DictionariesLocationModel,
  UpdateDictionariesLocationModel,
} from "../../../viewModels/Dictionaries/DictionariesLocationModel";

import { DigitalLogistCarrierBasicInfoModel } from "../../../viewModels/Carriers/DigitalLogistCarrierModel";
import { LOCATIONS_DICTIONARY_PAGE_TAB_KEYS } from "./constants";
import SortObject from "../../../types/SortObject";
import { SwapLocationFormInput } from "../../../components/SwapLocationModal";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  activeTab: LOCATIONS_DICTIONARY_PAGE_TAB_KEYS;

  locations: Array<DictionariesLocationModel>;

  carriers: Array<DigitalLogistCarrierBasicInfoModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;
  searchFilterValue: string;

  locationIdToEdit: number;
  isEditLocationDrawerOpen: boolean;
  isEditLocationsDrawerLoading: boolean;

  locationToSwap: DictionariesLocationModel;
  isSwapLocationModalOpen: boolean;
  isSwapLocationModalLoading: boolean;
} = {
  loading: true,
  loadingData: true,
  activeTab: LOCATIONS_DICTIONARY_PAGE_TAB_KEYS.ALL,

  locations: undefined!,

  carriers: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,
  searchFilterValue: "",

  locationIdToEdit: undefined!,
  isEditLocationsDrawerLoading: false,
  isEditLocationDrawerOpen: false,

  locationToSwap: undefined!,
  isSwapLocationModalLoading: false,
  isSwapLocationModalOpen: false,
};

const dictionariesLocationsSlice = createSlice({
  name: "dictionariesLocations",
  initialState,
  reducers: {
    loadLocations(state) {
      state.loadingData = true;
      state.page = 1;
    },
    setLoadedLocations(
      state,
      action: PayloadAction<{
        locations: Array<DictionariesLocationModel>;
        total: number;
      }>,
    ) {
      const { locations, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.locations = locations;
      state.total = total;
    },
    setActiveTab: (state, action: PayloadAction<LOCATIONS_DICTIONARY_PAGE_TAB_KEYS>) => {
      state.loadingData = true;
      state.activeTab = action.payload;
    },
    loadLocationsReject(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
    openEditLocationDrawer(state, action: PayloadAction<number | undefined>) {
      state.locationIdToEdit = action.payload!;
      state.isEditLocationDrawerOpen = true;
    },
    closeEditLocationDrawer(state) {
      if (!state.isEditLocationsDrawerLoading) {
        state.locationIdToEdit = undefined!;
        state.isEditLocationDrawerOpen = false;
      }
    },

    createLocation(state, _action: PayloadAction<CreateDictionariesLocationModel>) {
      state.isEditLocationsDrawerLoading = true;
    },
    createLocationSuccess(state) {
      state.isEditLocationsDrawerLoading = false;
      state.isEditLocationDrawerOpen = false;
    },
    createLocationReject(state) {
      state.isEditLocationsDrawerLoading = false;
      state.isEditLocationDrawerOpen = false;
    },

    updateLocation(state, _action: PayloadAction<UpdateDictionariesLocationModel>) {
      state.isEditLocationsDrawerLoading = true;
    },
    updateLocationSuccess(state) {
      state.isEditLocationsDrawerLoading = false;
      state.isEditLocationDrawerOpen = false;
    },
    updateLocationReject(state) {
      state.isEditLocationsDrawerLoading = false;
      state.isEditLocationDrawerOpen = false;
    },

    loadCarriers() {},
    loadCarriersSuccess(state, action: PayloadAction<Array<DigitalLogistCarrierBasicInfoModel>>) {
      state.carriers = action.payload;
    },

    openSwapLocationModal(state, action: PayloadAction<DictionariesLocationModel>) {
      state.locationToSwap = action.payload;
      state.isSwapLocationModalOpen = true;
    },
    closeSwapLocationModal(state) {
      if (!state.isSwapLocationModalLoading) {
        state.locationToSwap = undefined!;
        state.isSwapLocationModalOpen = false;
      }
    },

    swapLocation(state, _action: PayloadAction<SwapLocationFormInput>) {
      state.isSwapLocationModalLoading = true;
    },
    swapLocationSuccess(state) {
      state.isSwapLocationModalLoading = false;
      state.isSwapLocationModalOpen = false;
      state.locationToSwap = undefined!;
    },
    swapLocationReject(state) {
      state.isSwapLocationModalLoading = false;
    },
  },
});

export default dictionariesLocationsSlice;
